import { memo } from 'react';
import cn from 'classnames';
import { DatePicker, Form, TimePicker, Upload, UploadFile } from 'antd';
import { Props } from './types';
import styles from './style.module.css';
import { Input } from 'antd';
import dayjs from 'dayjs';
import { UploadChangeParam } from 'antd/es/upload';
import { UploadOutlined } from '@ant-design/icons';

const FormPopup = memo(
  ({ fileList, onFileChange, errors, handleFocus }: Props) => {
    const handleFileChange = (event: UploadChangeParam<UploadFile<any>>) => {
      handleFocus();
      if (onFileChange) onFileChange(event);
    };

    return (
      <>
        <Form name="validateOnly" layout="vertical" autoComplete="off">
          <div className={cn(styles.reportMain, styles.newList)}>
            <div className={styles.selectReport}>
              <Form.Item
                name="fileList"
                validateStatus={
                  errors.fileList ? errors.fileList.validateStatus : ''
                }
                help={errors.fileList ? errors.fileList.help : ''}
                rules={[
                  {
                    required: true,
                    message: 'Загрузите файл',
                  },
                ]}
              >
                <Upload
                  fileList={fileList}
                  onChange={handleFileChange}
                  beforeUpload={() => false}
                  maxCount={1}
                  accept=".xlsx"
                >
                  <div className={styles.fileUpload}>
                    <span className={styles.fileUploadIcon}>
                      <UploadOutlined
                        style={{ color: '#1677ff', fontSize: '24px' }}
                      />
                    </span>
                    <div className={styles.fileUploadWrapper}>
                      <div className={styles.fileUploadHead}>
                        <span className={styles.fileUploadTitle}>
                          Выберите файл (.xslx)
                        </span>
                        {!fileList || fileList.length === 0 ? (
                          <span className={styles.fileUploadSubtitle}>
                            Файл не выбран
                          </span>
                        ) : null}
                      </div>
                      <span className={styles.fileUploadNote}>
                        Заполните файл в соответствии с шаблоном
                      </span>
                    </div>
                  </div>
                </Upload>
              </Form.Item>
            </div>
          </div>
          <p className={styles.uploadWarning}>
            <span className={styles.warningLabel}>Внимание!</span> Рекомендуем
            загружать файл заранее: загружаются только приемы на завтра и
            позднее. Звонки выполняются за день до визита.
          </p>
        </Form>
      </>
    );
  },
);

FormPopup.displayName = 'FormPopup';
export default FormPopup;
